import { useProductAccessByApiAccountQuery } from "@sso/apis/apiAccountProducts";
import { DialogBody, DialogHeader } from "@sso/components/Dialogs/components";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { ProductByApiAccount } from "@sso/types";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { Table, TH } from "@sso/ui/Table";
import { TD } from "@sso/ui/Table";
import { Typography } from "@sso/ui/Typography";

import { ApiAccountProductToggleRole } from "./ApiAccountProductToggleRole";

const columns = [{ name: "Product", field: "name" }];

export const ApiAccountProductDialog = () => {
  const { id: apiAccountId } = useAppSelector(selectDialog);

  const { data: products, isLoading, isError } = useProductAccessByApiAccountQuery(apiAccountId as string);

  const data: ProductByApiAccount[] = !products ? [] : products;

  const DialogContent = () => {
    if (isLoading) {
      return <CircleLoading top="50px" blurBackground />;
    } else if (isError) {
      return <Typography margin="3rem 0 0">Something went wrong!</Typography>;
    } else if (data.length === 0) {
      return <Typography margin="3rem 0 0">There are no products for this API account.</Typography>;
    }
    return (
      <Table>
        <thead>
          <tr>
            {columns.map(column => (
              <TH key={column.field} textAlign="center">
                {column.name}
              </TH>
            ))}
            <TH textAlign="center">Roles</TH>
          </tr>
        </thead>
        <tbody>
          {data.map(product => (
            <tr key={product.softwareId}>
              {columns.map(col => (
                <TD key={col.field} textAlign="center" padding="1rem 0.4rem">
                  <Typography display="initial" size="1.2rem">
                    {(product as unknown as Record<string, string>)[col.field]}
                  </Typography>
                </TD>
              ))}
              <TD>
                {product.roles.map(role => (
                  <div
                    key={role.roleId}
                    style={{ display: "flex", alignContent: "center", flexDirection: "row", margin: "0.5rem" }}
                  >
                    <ApiAccountProductToggleRole
                      apiAccountId={apiAccountId as string}
                      softwareId={role.softwareId as string}
                      roleId={role.roleId as string}
                      hasRole={product.assignedRoles.includes(role.roleId)}
                    />
                    <Typography display="initial" size="0.8rem" style={{ paddingLeft: "0.5rem" }}>
                      {role.name}
                    </Typography>
                  </div>
                ))}
              </TD>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <>
      <DialogHeader title={DialogTitle.API_ACCOUNT_PRODUCT} />
      <DialogBody padding="0 0 1rem" minHeight="150px">
        <Flex position="relative" height="100%">
          <DialogContent />
        </Flex>
      </DialogBody>
    </>
  );
};
